import { Box } from "@mui/material";
import { PartDetails } from "../../../../explorer/types/SpareParts/PartDetails";
import AppIconButtonHeader from "../../AppButtons/AppIconButtonHeader";
import { AppIconsOpen, AppIconsClose } from "../../AppIcons";
import { ManufacturerLogo } from "../../ManufacturerLogo/ManufacturerLogo";
import { AppIconsReplacedCustom, BoxDescription, BoxLeft, BoxRight, DrawerHeaderBox, PartDetailsCode } from "./DrawerPartDetails.styles";
import { usePartDetails } from "../../../hook/usePartDetails";
import useGoToPage from "../../../hook/useGoToPage";

export type DrawerHeaderProps = PartDetails & {replacedCode?: string | undefined}


const DrawerHeader: React.FC<React.PropsWithChildren<DrawerHeaderProps>> = (
    props: React.PropsWithChildren<DrawerHeaderProps>
) => {
    const { closePartDetails } = usePartDetails();
    const goToPage = useGoToPage();
    const partDetails = props;

    const handleClickCloseButton = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        closePartDetails();
    }

    const handleClickExpandButton = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        // Da aggiungere il GoToPage
        goToPage.spareParts.goToPartDetails(partDetails!.code);
    }

    return (
        <DrawerHeaderBox>
            <BoxLeft>
                {partDetails?.manufacturerCompanyCode && <ManufacturerLogo manufacturer={partDetails?.manufacturerCompanyCode} />}
                <Box flexGrow={"1"} sx={{ width: "100%" }}>
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                        {props.replacedCode ? <AppIconsReplacedCustom /> : null}
                        <PartDetailsCode>
                            {partDetails?.code}
                        </PartDetailsCode>
                    </Box>
                    <BoxDescription>{partDetails?.partDescriptions ? partDetails?.partDescriptions[0]?.description : ""}</BoxDescription>
                </Box>
            </BoxLeft>
            <BoxRight>
                <AppIconButtonHeader onClick={handleClickExpandButton}>
                    <AppIconsOpen />
                </AppIconButtonHeader>

                <AppIconButtonHeader onClick={handleClickCloseButton}>
                    <AppIconsClose />
                </AppIconButtonHeader>
            </BoxRight>
        </DrawerHeaderBox>
    );
};

export default DrawerHeader;